import { render, staticRenderFns } from "./sales-order-dashboard-card.vue?vue&type=template&id=b5860922&scoped=true&"
import script from "./sales-order-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./sales-order-dashboard-card.vue?vue&type=script&lang=js&"
import style0 from "./sales-order-dashboard-card.vue?vue&type=style&index=0&id=b5860922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5860922",
  null
  
)

export default component.exports